import { ArrowRight } from 'lucide-react';
import type { PainPoint } from '../content';

export function PainPointSection({ items }: { items: PainPoint[] }) {
  return (
    <section className="pain-section">
      <div className="section-inner">
        <div className="section-heading compact">
          <p className="eyebrow">The real problem</p>
          <h2>Marketing teams are not short on tools. They are short on confidence.</h2>
          <p>
            Every disconnected list, landing page, QR code, and approval thread creates one more chance to disappoint a guest, frustrate a location, or lose the story behind the results.
          </p>
        </div>
        <div className="pain-grid">
          {items.map((item) => (
            <article className="pain-card" key={item.problem}>
              <p className="problem">{item.problem}</p>
              <ArrowRight size={18} />
              <p className="solution">{item.solution}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
